import { useState, type FormEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from '@/shared/ui/inputs/Input';
import { Button } from '@/shared/ui/buttons/Button';
import { env } from '@/shared/lib/env';

type DevLoginFormProps = {
  onSubmit: (access: string, refresh: string) => void;
  disabled?: boolean;
};

export const FeaturesAuthDevLoginForm = ({ onSubmit, disabled }: DevLoginFormProps) => {
  const { t } = useTranslation('login');
  const [access, setAccess] = useState('');
  const [refresh, setRefresh] = useState('');

  if (!env.enableDevLogin) return null;

  const handle = (e: FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    const trimmedAccess = access.trim();
    const trimmedRefresh = refresh.trim();
    // Guard against blank or whitespace-only tokens, otherwise an empty
    // access token would be stored and the user "authenticated" with no token.
    if (!trimmedAccess || !trimmedRefresh) return;
    onSubmit(trimmedAccess, trimmedRefresh);
  };

  return (
    <details className="rounded-2xl border border-slate-200 bg-white p-4 shadow-card">
      <summary className="cursor-pointer text-sm font-semibold text-ink-soft">
        {t('devTitle')}
      </summary>
      <form onSubmit={handle} className="mt-3 flex flex-col gap-3">
        <Input
          label={t('devAccessLabel')}
          value={access}
          onChange={(e) => setAccess(e.target.value)}
          placeholder="eyJhbGciOi..."
          autoComplete="off"
          spellCheck={false}
        />
        <Input
          label={t('devRefreshLabel')}
          value={refresh}
          onChange={(e) => setRefresh(e.target.value)}
          placeholder="eyJhbGciOi..."
          autoComplete="off"
          spellCheck={false}
        />
        <Button type="submit" variant="outline" disabled={disabled}>
          {t('devSubmit')}
        </Button>
      </form>
    </details>
  );
};
